var _g, _circle, _rect, _g2, _rect2, _rect3, _rect4, _g3, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _rect0, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactNewUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 264,
    viewBox: "0 0 319 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_diamond_936_5887_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.106347 0.255233 -0.255233 -0.106347 128.141 127.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 605.285,
    height: 605.285,
    fill: "url(#paint0_diamond_936_5887)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 605.285,
    height: 605.285,
    transform: "scale(1 -1)",
    fill: "url(#paint0_diamond_936_5887)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 605.285,
    height: 605.285,
    transform: "scale(-1 1)",
    fill: "url(#paint0_diamond_936_5887)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 605.285,
    height: 605.285,
    transform: "scale(-1)",
    fill: "url(#paint0_diamond_936_5887)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128.141,
    cy: 127.25,
    r: 127.25,
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.062745101749897003,\"g\":0.63921570777893066,\"b\":0.49803921580314636,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.90980392694473267,\"g\":0.91372549533843994,\"b\":0.92941176891326904,\"a\":1.0},\"position\":0.64999997615814209},{\"color\":{\"r\":0.90980392694473267,\"g\":0.91372549533843994,\"b\":0.92941176891326904,\"a\":1.0},\"position\":0.65206468105316162}],\"stopsVar\":[{\"color\":{\"r\":0.062745101749897003,\"g\":0.63921570777893066,\"b\":0.49803921580314636,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.90980392694473267,\"g\":0.91372549533843994,\"b\":0.92941176891326904,\"a\":1.0},\"position\":0.64999997615814209},{\"color\":{\"r\":0.90980392694473267,\"g\":0.91372549533843994,\"b\":0.92941176891326904,\"a\":1.0},\"position\":0.65206468105316162}],\"transform\":{\"m00\":-212.69454956054688,\"m01\":-510.46685791015625,\"m02\":489.72134399414062,\"m10\":510.46685791015625,\"m11\":-212.69454956054688,\"m12\":-21.636165618896484},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.6953,
    y: 22.0039,
    width: 198.759,
    height: 61.6081,
    rx: 5.86743,
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_5887)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6023,
    height: 17.6023,
    transform: "translate(64.6953 44.0068)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.6953,
    y: 44.0068,
    width: 17.6023,
    height: 17.6023,
    rx: 8.80115,
    fill: "#10A37F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.1602,
    y: 45.5166,
    width: 14.6686,
    height: 13.8922,
    rx: 6.94611,
    fill: "#10A37F"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100.637,
    y: 38.5049,
    width: 31.5375,
    height: 8.98451,
    rx: 4.49226,
    fill: "#16C098",
    fillOpacity: 0.45
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100.637,
    y: 54.6406,
    width: 92.4121,
    height: 8.98451,
    rx: 4.49226,
    fill: "#16C098",
    fillOpacity: 0.45
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.2656,
    y: 202,
    width: 198.759,
    height: 61.6081,
    rx: 5.86743,
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_936_5887)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6023,
    height: 17.6023,
    transform: "translate(65.2656 224.002)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.2656,
    y: 224.003,
    width: 17.6023,
    height: 17.6023,
    rx: 8.80115,
    fill: "#10A37F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.7344,
    y: 225.513,
    width: 14.6686,
    height: 13.8922,
    rx: 6.94611,
    fill: "#10A37F"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 101.207,
    y: 218.501,
    width: 31.5375,
    height: 8.98451,
    rx: 4.49226,
    fill: "#16C098",
    fillOpacity: 0.45
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 101.207,
    y: 234.637,
    width: 92.4121,
    height: 8.98451,
    rx: 4.49226,
    fill: "#16C098",
    fillOpacity: 0.45
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 202.109,
    y: 105,
    width: 116,
    height: 62,
    rx: 5.86743,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 212.109,
    y: 117,
    width: 89,
    height: 9,
    rx: 4.5,
    fill: "#16C098",
    fillOpacity: 0.45
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 212.109,
    y: 131,
    width: 45,
    height: 9,
    rx: 4.5,
    fill: "#16C098",
    fillOpacity: 0.45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M289.11 151.17L284.94 147L283.52 148.41L289.11 154L301.11 142L299.7 140.59L289.11 151.17Z",
    fill: "#10A37F"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 82.1094,
    y: 106,
    width: 114,
    height: 60,
    rx: 4.86743,
    stroke: "white",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.109 137H140.109V143H138.109V137H132.109V135H138.109V129H140.109V135H146.109V137Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_diamond_936_5887_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 128.141,
    cy: 127.25,
    r: 127.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_diamond_936_5887",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10A37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#E8E9ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652065,
    stopColor: "#E8E9ED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_5887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6023,
    height: 17.6023,
    fill: "white",
    transform: "translate(64.6953 44.0068)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_936_5887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6023,
    height: 17.6023,
    fill: "white",
    transform: "translate(65.2656 224.002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactNewUserIcon);
export default __webpack_public_path__ + "static/media/ContactNewUserIcon.8758d30c8e9967870127f189a309bc09.svg";
export { ForwardRef as ReactComponent };